
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity/partnerships",
      function () {
        return require("private-next-pages/docs/identity/partnerships/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity/partnerships"])
      });
    }
  